export default {"src":"/_next/static/media/other.b463c7d3.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};